import { parseCloudId } from './cloud-id';
import { parseDependsOn } from './depends-on';
import { parseNumberFormat } from './number-format';
import { type ConfigurationDefinition, type FieldConfiguration } from './types';

const CONFIGURATION_PARSERS: ConfigurationDefinition[] = [
  {
    prefix: 'number_format:',
    parser: parseNumberFormat,
  },
  {
    prefix: 'depends_on:',
    parser: parseDependsOn,
  },
  {
    prefix: 'cloud_id:',
    parser: parseCloudId,
  },
];

export function parseConfiguration(configString: string): FieldConfiguration | null {
  if (!configString || typeof configString !== 'string') {
    return null;
  }

  const trimmed = configString.trim();
  if (!trimmed) {
    return null;
  }

  for (const definition of CONFIGURATION_PARSERS) {
    if (trimmed.startsWith(definition.prefix)) {
      const value = trimmed.substring(definition.prefix.length);
      const result = definition.parser(value);
      return result ?? null;
    }
  }

  return null;
}

export type { FieldConfiguration } from './types';
